import { clubFetch } from '@club/api/utils'
import commentMapper from '@club/api/mapper/comment'
import type { Comment } from '@club/types/Comment'

export default class CommentAPI {
  fetchComments (articleId: number, options: { communityExternalIds?: string[]; } = {}): Promise<Comment[]> {
    const { communityExternalIds } = options
    const params: Record<string, unknown> = {}

    if (communityExternalIds) {
      params['external_id[]'] = communityExternalIds
    }

    params['article.id'] = articleId

    return clubFetch<{ 'hydra:member': unknown[] }>('/comments', { params })
      .then(response => {
        const comments = response['hydra:member']
        return comments.map(item => commentMapper.toClient(item))
      })
  }

  sendMessage ({ articleId, ...payload }: {
    articleId: number,
    payload: Record<string, string>
  }): Promise<Comment> {
    return clubFetch<unknown>('/comments', {
      method: 'POST',
      body: {
        ...payload,
        article: `/community/api/v1/articles/${articleId}`
      }
    })
      .then(response => commentMapper.toClient(response))
  }
}
